import {Hydra} from '../generic/hydra';

import {FieldInterface} from './Field';
import {FormulaireSaisieInterface} from './FormulaireSaisie';
import {FieldValue as FieldValueBaseInterface} from '../../interface/api/FieldValue';

export type FieldValueInterface = FieldValueBaseInterface;

export class FieldValue extends Hydra implements FieldValueInterface {

    id?: number | null;

    field?: FieldInterface | string | null;

    formulaireSaisie?: FormulaireSaisieInterface | string | null;

    value?: string | null;


    constructor(options: FieldValueInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
